import { fetch } from '@atlassian/eoc-fetch';
export const getSavedSearchesEndpoint = () => {
  return fetch('/v1/alerts/saved-searches');
};
export const createSavedSearchEndpoint = data => {
  return fetch('/v1/alerts/saved-searches', {
    method: 'POST',
    body: data
  });
};
export const deleteSearchEndpoint = id => {
  return fetch(`/v1/alerts/saved-searches/${id}`, {
    method: 'DELETE',
    responseType: 'headers'
  });
};